import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useAuth } from "@/hooks/useAuth";

export default function SentryUserSync() {
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      Sentry.setUser({
        id: String(user.id),
        email: user.email ?? undefined,
        username: user.username ?? undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isAuthenticated, user?.id]);

  return null;
}
